import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  patchPortfolio,
  selectPortfolioMode,
} from "@/store/slices/portfolioSlice";
import MultiAsset from "./multiAsset";
import SingleAsset from "./singleAsset";
import {
  ScorecardParityToolbar,
  useParityComputeSource,
} from "@/dev/scorecardParityTestkit";

const ScorecardHome = () => {
  const dispatch = useDispatch();
  const multiAssetToggle = useSelector(selectPortfolioMode);
  const [rerenderKey, setRerenderKey] = useState(0);
  const {
    parityTestkitEnabled,
    paritySeed,
    computeSource,
    usePyScorecard,
    setComputeSource,
  } = useParityComputeSource();

  const handleMultiAssetToggle = useCallback(
    (value) => {
      dispatch(patchPortfolio({ mode: value }));
    },
    [dispatch]
  );

  const triggerRerender = () => {
    setRerenderKey((prevKey) => prevKey + 1);
  };

  return (
    <>
      <div className="w-full mx-auto max-w-7xl px-4 pt-5">
        {parityTestkitEnabled && (
          <ScorecardParityToolbar
            source={computeSource}
            onSourceChange={setComputeSource}
          />
        )}
      </div>
      {multiAssetToggle === "singleAsset" && (
        <SingleAsset
          usePyScorecard={usePyScorecard}
          multiAssetToggle={multiAssetToggle}
          handleMultiAssetToggle={handleMultiAssetToggle}
        />
      )}
      {multiAssetToggle === "differentAsset" && (
        <MultiAsset
          key={rerenderKey}
          usePyScorecard={usePyScorecard}
          multiAssetToggle={multiAssetToggle}
          handleMultiAssetToggle={handleMultiAssetToggle}
          triggerRerender={triggerRerender}
        />
      )}
    </>
  );
};

export default ScorecardHome;
